import { Pagination, PropertySearcherUserBean } from '@ui/shared/model';

import {
  ACTIVATE_PROPERTY_SEARCHER,
  ACTIVATE_PROPERTY_SEARCHER_FAIL,
  ACTIVATE_PROPERTY_SEARCHER_SUCCESS,
  FETCH_PROPERTY_SEARCHER_USERS,
  FETCH_PROPERTY_SEARCHER_USERS_FAIL,
  FETCH_PROPERTY_SEARCHER_USERS_SUCCESS,
  IMPERSONATE_PROPERTY_SEARCHER,
  IMPERSONATE_PROPERTY_SEARCHER_FAIL,
  IMPERSONATE_PROPERTY_SEARCHER_SUCCESS,
  PropertySearcherAction,
  REVOKE_PROPERTY_SEARCHER_PHONE_VERIFICATION,
  REVOKE_PROPERTY_SEARCHER_PHONE_VERIFICATION_FAIL,
  REVOKE_PROPERTY_SEARCHER_PHONE_VERIFICATION_SUCCESS,
  VERIFY_PROPERTY_SEARCHER_PHONE_AS_ADMIN,
  VERIFY_PROPERTY_SEARCHER_PHONE_AS_ADMIN_FAIL,
  VERIFY_PROPERTY_SEARCHER_PHONE_AS_ADMIN_SUCCESS
} from './property-searcher.actions';

export interface PropertySearcherState {
  usersData: PropertySearcherUserBean[];
  isLoading: boolean;
  loaded: boolean;
  error: string;
  pagination: Pagination;
}

export const initialState: PropertySearcherState = {
  usersData: [],
  isLoading: false,
  loaded: false,
  error: null,
  pagination: null
};

export function reducer(
  state = initialState,
  action: PropertySearcherAction
): PropertySearcherState {
  switch (action.type) {
    case FETCH_PROPERTY_SEARCHER_USERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        usersData: action.data,
        loaded: true,
        pagination: action.pagination
      };
    }

    case ACTIVATE_PROPERTY_SEARCHER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loaded: true
      };
    }

    case IMPERSONATE_PROPERTY_SEARCHER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loaded: true
      };
    }

    case VERIFY_PROPERTY_SEARCHER_PHONE_AS_ADMIN_SUCCESS:
    case REVOKE_PROPERTY_SEARCHER_PHONE_VERIFICATION_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loaded: true
      };
    }

    case FETCH_PROPERTY_SEARCHER_USERS:
    case ACTIVATE_PROPERTY_SEARCHER:
    case IMPERSONATE_PROPERTY_SEARCHER:
    case VERIFY_PROPERTY_SEARCHER_PHONE_AS_ADMIN:
    case REVOKE_PROPERTY_SEARCHER_PHONE_VERIFICATION: {
      return {
        ...state,
        isLoading: true
      };
    }

    case FETCH_PROPERTY_SEARCHER_USERS_FAIL:
    case ACTIVATE_PROPERTY_SEARCHER_FAIL:
    case IMPERSONATE_PROPERTY_SEARCHER_FAIL:
    case VERIFY_PROPERTY_SEARCHER_PHONE_AS_ADMIN_FAIL:
    case REVOKE_PROPERTY_SEARCHER_PHONE_VERIFICATION_FAIL: {
      return {
        ...state,
        isLoading: false,
        loaded: false,
        error: action.error
      };
    }

    default:
      return state;
  }
}

export const getPropertySearcherUserData = (state: PropertySearcherState) =>
  state.usersData;
export const getPropertySearcherLoading = (state: PropertySearcherState) =>
  state.isLoading;
export const getPropertySearcherLoaded = (state: PropertySearcherState) =>
  state.loaded;
export const getError = (state: PropertySearcherState) => state.error;
export const getpagination = (state: PropertySearcherState) => state.pagination;
